const {
	default: { breakXtraSmall, breakMedium },
} = require('util/sass-variables');
const MiniSwipe = require('util/miniSwipe');
const {
	mediaQueryMin,
	fillWithDomElements,
	fillWithDomElementsAll,
	trackGtm,
	trackGtm4,
} = require('util/functions');

const CLASS_PREVIOUS = 'carousel-highlight-nav--previous';
const CLASS_NEXT = 'carousel-highlight-nav--next';
const CLASS_DOTS = 'carousel-highlight-nav--dots';
const CLASS_NAV = 'carousel-highlight-nav';
const CLASS_CONTENT = 'carousel-highlight--content';
const CLASS_TITLE = 'carousel-highlight--title';

const CLASS_DOT = 'carousel-highlight-nav--dot';
const CLASS_MODAL = 'modal-controller';
const CLASS_MODAL_OPENER = 'modal-opener';

const CLASS_SMALL_IMAGE = 'small-image-above-title';
const CLASS_FAQ = 'faq-block';

const CLASS_LINK = 'carousel-highlight--bottom-link';

const selectors = {
	title: CLASS_TITLE,
	previousButton: CLASS_PREVIOUS,
	nextButton: CLASS_NEXT,
	dotContainer: CLASS_DOTS,
	nav: CLASS_NAV,
	content: CLASS_CONTENT,
	link: CLASS_LINK,
};
const selectorsAll = {
	dots: CLASS_DOT,
	modals: CLASS_MODAL,
};

module.exports = {
	...{
		init() {
			const isFAQ = !!this.root.querySelector('.' + CLASS_FAQ);
			fillWithDomElements(this, selectors);
			fillWithDomElementsAll(this, {
				...selectorsAll,
				swipedList: isFAQ ? CLASS_FAQ : CLASS_SMALL_IMAGE,
			});
			this.initDots();
			this.initSwiper();

			this.previousButton.addEventListener('click', () => {
				this.previous();
				this.gtmTracking('previous', null, null, this.previousButton);
			});
			this.nextButton.addEventListener('click', e => {
				this.next();
				this.gtmTracking('next', null, null, this.nextButton);
			});
			this.link?.addEventListener('click', e => {
				this.gtmTracking('link', 'cta', e.target.innerText);
				this.gtm4Tracking(e.target.innerHTML, e.target.href);
			});
			// prevent drag effect on desktop panning
			this.content.addEventListener('dragstart', e => e.preventDefault());
			if (this.root.dataset.modal) this.initModals();
		},
		initDots() {
			const widgetName = this.root.getAttribute('data-parent');
			const titleText = this.title
				? this.title.textContent
				: 'Title is not set';
			this.dotContainer.addEventListener('click', ({ target }) => {
				if (target.classList.contains(CLASS_DOT)) {
					const index = [...this.dots].indexOf(target);
					this.jumpToIndex(index);

					if (widgetName && this.root.dataset.ga4tracking) {
						const pageNumber = target.textContent.split(/\s+/);

						trackGtm4({
							event: 'GA4_event_c_content_navigation_click',
							widget_name: widgetName,
							widget_title: titleText,
							widget_type:
								widgetName === 'V3-Latest-market-pages-news'
									? 'article'
									: 'video',
							link_text: target.textContent.trim(),
							link_url: 'No url',
							interaction_type: `bullet ${pageNumber[1]}`,
						});
					}
				}
			});
		},
		initSwiper() {
			this.markTilesActive = true;
			this.initialize({
				swipedList: this.swipedList,
				touchZone: this.content,
				swipeContainer: this.content,
			});
		},
		initModals() {
			this.swipedList.forEach((widget, index) => {
				widget
					.querySelector('.' + CLASS_MODAL_OPENER)
					?.addEventListener('click', () =>
						this.modals[index].__controller.open(),
					);
			});
		},
		gtm4Tracking(linkText, linkURL) {
			const widgetName = this.root.getAttribute('data-parent');
			const widgetTitle = this.root.getAttribute('data-parent-title');
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: widgetName,
				widget_title: widgetTitle ? widgetTitle : 'No title: title not set',
				link_text: linkText,
				link_url: linkURL,
				button_type: '',
			});
		},
		gtmTracking(eventAction, category, label, target) {
			let eventCategory;
			let eventLabel;
			const widgetName = this.root.getAttribute('data-parent');
			const titleText = this.title
				? this.title.textContent
				: 'Title is not set';
			if (category) {
				eventCategory = category;
			} else {
				eventCategory = 'content-navigation';
			}
			if (label) {
				eventLabel = label;
			} else {
				eventLabel = `${titleText} | ${widgetName}`;
			}
			trackGtm({
				event: 'GA tracking',
				eventCategory: eventCategory,
				eventAction: eventAction,
				eventLabel: eventLabel,
			});

			if (widgetName && this.root.dataset.ga4tracking) {
				const checkText =
					target.innerHTML.trim().length == 0
						? 'No text'
						: target
						? target.innerHTML.trim()
						: eventAction;
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: widgetName,
					widget_title: titleText,
					widget_type:
						widgetName === 'V3-Latest-market-pages-news' ? 'article' : 'video',
					link_text: checkText,
					link_url: 'No url',
					interaction_type: eventAction,
				});
			}
		},
		onResize() {
			this.currentOffset = 0;
			this.setOffset(0);
			this.viewablesCount = 1;
			this.target = 0;
			if (mediaQueryMin(breakXtraSmall)) {
				const count = mediaQueryMin(breakMedium) ? 3 : 2;
				this.viewablesCount = count;
				if (this.notches.length <= count) this.nav.style.display = 'none';
				else this.nav.style.display = null;
			}
			this.defineNotches();
			this.previousButton.disabled = true;
			this.nextButton.disabled = false;
			this.setTilesActive();
		},
		onFirst() {
			this.previousButton.disabled = true;
		},
		offFirst() {
			this.previousButton.disabled = false;
		},
		onLast() {
			this.nextButton.disabled = true;
		},
		offLast() {
			this.nextButton.disabled = false;
		},
		onUpdate(currentIndex) {
			this.dots.forEach((dot, index) => {
				dot.disabled = index === currentIndex;
			});
		},
	},
	...MiniSwipe,
};
